import { useState, useEffect, Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CurrencyInput from 'react-currency-input-field';
import Select from 'react-select';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { setAlert } from '../../actions/alert';
import { crearRenta } from '../../actions/locatarios';

import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const NuevaRenta = ({ renta, reestablecerRenta }) => {

    const dispatch = useDispatch();

    const [rentaData, setRentaData] = useState({
        id: null, 
        fecha: null, 
        total: null, 
        metodo: null, 
        observaciones: ''
    });

    const [metodoData, setMetodoData] = useState(null);
    const metodosFilter = [
        { value: 0, label: 'Efectivo' },
        { value: 1, label: 'Tarjeta' },
        { value: 2, label: 'Transferencia' }
    ];

    const [rentaModal, setRentaModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }), 
        container: (provided, state) => ({
            ...provided, 
        }),
        control: (provided, state) => ({
            ...provided,
            paddingTop: '5px',
            paddingBottom: '5px',
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible", 
            marginTop: "10px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    /* Agregar renta */
    const handleAbrir = () => {
        if(renta?.locatario){
            setRentaData({
                ...rentaData, 
                id: renta.locatario, 
                total: renta.total
            });
        }
    }

    const handleInputChange = ({ target }) => {
        setRentaData({
            ...rentaData,
            [target.name]: target.value
        });
    }

    const handleDatePicker = (name, value) => {
        setRentaData({
            ...rentaData,
            [name]: value
        });
    }

    const handleNumberChange = (value) => {
        setRentaData({
            ...rentaData,
            total: value || ''
        });
    }

    const handleSelectMetodo = (option) => {
        setMetodoData(option);

        setRentaData({
            ...rentaData,
            metodo: option != null ? option.value : null
        });
    }

    const handleProcesar = async () => {
        if(rentaData.fecha && rentaData.total && rentaData.metodo != null){
            await setStatusProcesar(true);

            await dispatch(crearRenta(rentaData));

            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('Todos los datos son requeridos', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setRentaData({
                id: null, 
                fecha: null, 
                total: null, 
                metodo: null, 
                observaciones: ''
            });

            setMetodoData(null);

            reestablecerRenta(null);
            setRentaModal(false);
        }
    }

    useEffect(() => {
        if(renta?.locatario){
            setRentaModal(true);

            setRentaData({
                ...rentaData, 
                id: renta.locatario, 
                total: renta.total
            });
        }
    }, [renta]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .delete {
                            padding: 0.39rem 0.70rem !important;
                            border-radius: 0 25% 25% 0 !important;
                            height: 100%;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <Modal show={rentaModal} size="lg" backdrop="static" centered onEntered={() => handleAbrir()} onHide={() => handleCerrar()}>
                <Modal.Header closeButton>
                    <Modal.Title>Nuevo pago de renta</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">

                        <div className="col-md-4 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <DatePicker
                                        id="fecha"
                                        name="fecha"
                                        className="form-control text-center input-datepícker"
                                        dateFormat="dd/MM/yyyy"
                                        locale="es-ES"
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        selected={ rentaData.fecha != null ? new Date(rentaData.fecha) : '' }
                                        onChange={ date => handleDatePicker('fecha', date) }
                                    />
                                    <label className="label-datepicker" htmlFor="fecha">Fecha de pago</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <CurrencyInput
                                        id="total"
                                        name="total"
                                        className="form-control text-center"
                                        value={rentaData.total || ''}
                                        decimalsLimit={2}
                                        groupSeparator=","
                                        decimalSeparator="."
                                        onValueChange={(value) => handleNumberChange(value)}
                                    />
                                    <label htmlFor="total">Total a cobrar</label>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 form-group mb-3">
                            <div className="input-group h-100">
                                <Select
                                    id="metodo"
                                    name="metodo"
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder="Método de pago"
                                    isClearable={true}
                                    options={metodosFilter}
                                    value={metodoData}
                                    onChange={(value) => handleSelectMetodo(value)}
                                    menuPortalTarget={document.body}
                                    components={{ ValueContainer: CustomValueContainer }}
                                    styles={{ ...styles_select }}
                                />
                            </div>
                        </div>

                        <div className="col-md-12 form-group mb-3">
                            <div className="input-group">
                                <div className="form-floating">
                                    <textarea className="form-control textareCampo" placeholder="Observaciones" id="observaciones" name="observaciones" value={rentaData.observaciones} onChange={e => handleInputChange(e)}></textarea>
                                    <label htmlFor="observaciones">Observaciones</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>

                    {
                        statusProcesar ?
                            <button type="button" className="btn btn-success mr-3" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                        :
                            <button type="button" className="btn btn-success mr-3" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                    }
                </Modal.Footer>
            </Modal>
        </Fragment>
    )
}

export default NuevaRenta;